// @ts-nocheck
/* eslint-disable */
import { node, icon } from "./util/dom";
import Scene from "~/scene";

const MATRIX_POSITION = [
	[0, 0, -1],
	[45, 1, -1],
	[90, 1, 0],
	[135, 1, 1],
	[180, 0, 1],
	[225, -1, 1],
	[270, -1, 0],
	[315, -1, -1],
	[360, 0, -1],
];

function getInterpolationSize(matrix: Array<[number, number, number]> = MATRIX_POSITION, step = 1): Array<[number, number, number]> {
	let result = [];

	for (let index = 0; index < matrix.length; index++) {
		if (index !== matrix.length - 1) {
			const actualArray = matrix[index];
			const nextArray = matrix[index+1];
			const diff = Math.abs(nextArray[0]) - Math.abs(actualArray[0]);
			const diffLeft = Math.abs(Math.abs(nextArray[1]) - Math.abs(actualArray[1]));
			const diffTop = Math.abs(Math.abs(nextArray[2]) - Math.abs(actualArray[2]));

			const leftMultiplier = actualArray[1] <= nextArray[1] ? 1 : -1;
			const topMultiplier = actualArray[2] <= nextArray[2] ? 1 : -1;

			result.push(actualArray);

			for (let interpolationStep = actualArray[0] + step; interpolationStep < nextArray[0]; interpolationStep += step) {
				const perc = (interpolationStep - actualArray[0]) / diff;

				result.push([interpolationStep, actualArray[1] + (diffLeft * leftMultiplier * perc), actualArray[2] + (diffTop * topMultiplier * perc)]);
			}
		}
	}

	return result;
}

Mapy.MarkerBubblePubt = function(coords, id, opts) {
	var _opts = {
		angle: 0,
		arrowWidth: 8,
		arrowHeight: 12,
		arrowAnchor: [0, 7],
		bubbleHeight: 32,
		bubbleWidth: 110,
		icon: icon("weather-marker-pointer"),
	};

	for (var p in opts) { _opts[p] = opts[p]; }

	SMap.Marker.call(this, coords, id, _opts);
};

Mapy.MarkerBubblePubt.prototype = Object.create(Object.assign({}, Mapy.MarkerCard.prototype, SMap.Marker.prototype));

Mapy.MarkerBubblePubt.prototype.setArrowAngle = function(angle) {
	if (angle !== undefined) {
		this._options.angle = angle % 360;
	}

	const matrixInterpolationSize = getInterpolationSize();

	let right = this._options.angle > 180;

	this._dom.arrow.classList[right ? "add" : "remove"]("right");

	var degrees = this._options.angle;

	this._dom.arrow.style.transform = `rotate(${degrees + 180}deg)`;

	if (this._options.elm) {
		const left = matrixInterpolationSize[degrees][1] * this._options.bubbleWidth / 2;
		const top = matrixInterpolationSize[degrees][2] * this._options.bubbleHeight / 2;
		const countLeft = left + this._options.arrowAnchor[1] * Math.sin(degrees*Math.PI/180);
		const countTop = top - this._options.arrowAnchor[1] * Math.cos(degrees*Math.PI/180);

		this._options.elm.style.left = `${countLeft}px`;
		this._options.elm.style.top = `${countTop}px`;

		this._options.elm.style.marginTop = `-${this._options.bubbleHeight / 2}px`;
		this._options.elm.style.marginLeft = `-${this._options.bubbleWidth / 2}px`;

		const coordsPixel = Scene.coordsToPixel(this._coords);

		return {
			left: coordsPixel.x + countLeft - this._options.bubbleWidth / 2,
			top: coordsPixel.y + countTop - this._options.bubbleHeight / 2,
			right: coordsPixel.x + countLeft + this._options.bubbleWidth / 2,
			bottom: coordsPixel.y + countTop + this._options.bubbleHeight / 2,
		};
	}

	return null;
}

Mapy.MarkerBubblePubt.prototype.setInnerElement = function(elm) {
	if (elm != undefined) {
		this._options.elm = elm;
	}
	else {
		return;
	}

	var div = this._dom.container[SMap.LAYER_MARKER];

	div.innerHTML = "";

	div.appendChild(this._dom.arrow);
	div.appendChild(this._options.elm);
}

Mapy.MarkerBubblePubt.prototype.setOptions = function(options) {
	this._options = {
		...this._options,
		...options,
	};
}

Mapy.MarkerBubblePubt.prototype.toggleClassName = function(method, className) {
	if (!method) {
		method = "add";
	}
	this._dom.container[SMap.LAYER_MARKER].classList[method](className);
}

Mapy.MarkerBubblePubt.prototype._build = function() {
	var div = node("div", { className: `marker-bubble${this._options.className ? ` ${this._options.className}`:``}` });

	var arrow = node("div", { className: "arrow" });
	arrow.appendChild(this._options.icon);
	div.appendChild(arrow);
	if (this._options.elm) {
		div.appendChild(this._options.elm);
	}

	this._dom.container[SMap.LAYER_MARKER] = div;
	this._dom.arrow = arrow;

	this.setArrowAngle();

	if (this._options.title) { this._dom.container[SMap.LAYER_MARKER].title = this._options.title; }
	this._dom.active = this._dom.container[SMap.LAYER_MARKER];
}
